import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { Card, Button, List, Label, Icon } from 'semantic-ui-react'

const styles = {
  listContentWrapper: {
    padding: '3px 0px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  actionButton: {
    display: 'flex',
    flexDirection: 'row',
  },
}

const Row = ({ field, value, color, timeValue }) => {
  return (
    <List.Item>
      <List.Content style={styles.listContentWrapper}>
        <div style={{ display: 'flex', flex: 1 }}>{field}</div>
        <div style={{ display: 'flex' }}>
          <Label size="medium" color={color}>
            {value}
          </Label>
          {timeValue && (
            <Label size="medium" color={color}>
              {timeValue}
            </Label>
          )}
        </div>
      </List.Content>
    </List.Item>
  )
}

const DealCard = ({ specialDeal, onDelete, onEdit, onView }) => {
  const countDownColor = specialDeal.countdown ? 'green' : 'red'
  const countDownValue = specialDeal.countdown ? 'Yes' : 'No'

  const startDate = moment(specialDeal.started_at).format('DD-MMM-YYYY')
  const expiredDate = moment(specialDeal.ended_at).format('DD-MMM-YYYY')

  const startTime = moment(specialDeal.started_at).format('hh:mm A')
  const endTime = moment(specialDeal.ended_at).format('hh:mm A')

  return (
    <Card style={{ marginLeft: 30 }}>
      <Card.Content>
        <Card.Header>
          <Label color="black" size="large" ribbon>
            {specialDeal.title_en}
          </Label>
          <span style={{ fontSize: 15 }}>{specialDeal.title_kh}</span>
        </Card.Header>
        <Card.Description>
          <List verticalAlign="middle" style={{ marginTop: 10 }}>
            <Row field="Countdown" value={countDownValue} color={countDownColor} />
            <Row field="Start Date" value={startDate} timeValue={startTime} />
            <Row field="End Date" value={expiredDate} timeValue={endTime} />
            <Row field="Items" value={_.size(specialDeal.items)} />
          </List>
        </Card.Description>
      </Card.Content>
      <Card.Content extra>
        <div style={styles.actionButton}>
          <Button icon color="black" size="tiny" onClick={onView} style={{ width: '100%' }}>
            <Icon name="eye" /> View
          </Button>
          <Button icon onClick={onEdit} size="tiny" style={{ width: '100%' }}>
            <Icon name="edit" /> Edit
          </Button>
          <Button icon color="red" onClick={onDelete} size="tiny" style={{ width: '100%' }}>
            <Icon name="delete" /> Delete
          </Button>
        </div>
      </Card.Content>
    </Card>
  )
}

export default DealCard



// WEBPACK FOOTER //
// ./src/components/specialDeal/dealCard.js